import { ValidHeimspielStatisticsProps } from './types'

const isValidHeimspielStatisticsProps = (
  props: any
): props is ValidHeimspielStatisticsProps => !!props?.matchId

export { isValidHeimspielStatisticsProps }
